// extracted by mini-css-extract-plugin
export default {"select":"LanguageSelector_select__Ouu5T"};